__turbopack_context__.v({
  "description": "index-module-scss-module__n6ZQsG__description",
  "disabled": "index-module-scss-module__n6ZQsG__disabled",
  "moreInfoTrigger": "index-module-scss-module__n6ZQsG__moreInfoTrigger",
  "moreInfoWrapper": "index-module-scss-module__n6ZQsG__moreInfoWrapper",
  "popover": "index-module-scss-module__n6ZQsG__popover",
  "popoverLine": "index-module-scss-module__n6ZQsG__popoverLine",
  "price": "index-module-scss-module__n6ZQsG__price",
  "richLabel": "index-module-scss-module__n6ZQsG__richLabel",
  "tag": "index-module-scss-module__n6ZQsG__tag",
  "title": "index-module-scss-module__n6ZQsG__title",
});
